/** 官网 SEO：统一写入 title / description / keywords / og / canonical */

export const SITE_ORIGIN = 'https://jsy.goldentaxcloud.com'
export const COMPANY_LEGAL_NAME = '金税云（山东）大数据服务有限公司'
export const COMPANY_SHORT_NAME = '山东金税云'
export const COMPANY_BRAND_NAME = '金税云大数据'
export const DEFAULT_KEYWORDS =
  '金税云,金税云大数据,山东金税云,金税云（山东）大数据服务有限公司,财税数字化,智能开票,纳税申报,税务风控'

const DEFAULT_DESCRIPTION =
  '金税云（山东）大数据服务有限公司（山东金税云）是国内领先的财税数智化综合解决方案提供商，提供业票财税银档一体化服务，助力企业合规降本增效。'

function upsertMeta(attr, key, content) {
  if (!content) return
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel, href) {
  if (!href) return
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * 根据路由 meta 与 path 更新页面 SEO 信息
 * 标签格式统一：金税云大数据—菜单名（keywords 仍保留完整检索词）
 * @param {{ title?: string, description?: string, keywords?: string, isHome?: boolean }} meta
 * @param {string} path
 */
export function applySeo(meta = {}, path = '/') {
  if (typeof document === 'undefined') return

  const menuTitle = meta.title || (meta.isHome ? '首页' : COMPANY_BRAND_NAME)
  const title = `${COMPANY_BRAND_NAME}—${menuTitle}`
  const description = meta.description || DEFAULT_DESCRIPTION
  const keywords = meta.keywords || DEFAULT_KEYWORDS
  const canonicalPath = path.split('?')[0] || '/'
  const canonical = `${SITE_ORIGIN}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}`

  document.title = title
  upsertMeta('name', 'description', description)
  upsertMeta('name', 'keywords', keywords)
  upsertMeta('property', 'og:title', title)
  upsertMeta('property', 'og:description', description)
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:url', canonical)
  upsertMeta('property', 'og:site_name', COMPANY_LEGAL_NAME)
  upsertMeta('property', 'og:locale', 'zh_CN')
  upsertLink('canonical', canonical)
}
